import Axios from 'axios';
import store from '@/store';
import router from '@/router';
import { getTimeZone } from '@/helpers/utils';
import Swal from 'sweetalert2';

let count = 0;

Axios.interceptors.request.use(
  function (config) {
    store.dispatch('loading/startLoading');
    count ++;

    const token = store.getters['authentication/getToken'];
    const { ID_PORTAL, API_URL } = store.getters['authentication/getConfig'];
    const portal = store.getters['dev/getSelectedPortal'];

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.timeZone = getTimeZone();
    config.headers.id_portal = ID_PORTAL;

    if (portal) config.headers.idPortalDev = portal.portalId;

    if (!config.baseURL && API_URL) {
      config.baseURL = `${API_URL}/api`;
    }

    return config;
  },

  function (error) {
    Promise.resolve(error).then(function ({ response }) {
      let message = '';

      if (response.data instanceof Array) {
        response.data.map(item => (message += `${item.message} <br>`));
      } else {
        message = response.data.message;
      }

      return store.dispatch('notification/showNotification', {
        color: 'error',
        text: message,
        showIconNotification: false
      });
    });

    count--;
    if(count === 0){
      store.dispatch('loading/finishLoading');
    }
  }
);

Axios.interceptors.response.use(
  function (response) {
    count--;
    if(count === 0){
      store.dispatch('loading/finishLoading');
    }

    return response;
  },

  function (error) {
    let responseError = error;

    Promise.resolve(error).then(function ({ response }) {
      if (!response) {
        store.dispatch('notification/showNotification', {
          color: 'error',
          text: responseError.Message || responseError.message || 'Internal Server Error',
          showIconNotification: false
        });

        return;
      }

      switch (response.status) {
        case 400: {
          let message = '';

          if (response.data instanceof Array) {
            response.data.map(item => (message += `${item.message} <br>`));
          } else {
            message = response.data.message;
          }

          store.dispatch('notification/showNotification', {
            color: 'error',
            text: message,
            showIconNotification: false
          });

          break;
        }

        case 401: {
          const message = store.getters['layout/getConfigExpiredMessage'];

          const alert = Swal.mixin({
            customClass: {
              confirmButton: `v-btn v-size--default error`
            }
          });

          alert.fire({
            text: !!message ? message : 'Sua sessão expirou. Faça seu login novamente.',
            icon: 'error',
            allowOutsideClick: false
          }).then(() => {
            return store.dispatch('authentication/logoff')
          });

          break;
        }

        case 403: {
          router.push({ path: '/403' });
          break;
        }

        case 404: {
          const alert = Swal.mixin({
            customClass: {
              confirmButton: `v-btn v-size--default primary`,
            },
            buttonsStyling: true
          });

            alert.fire({
            html: 'Encontramos um problema ao carregar algumas informações desta página.<br><br>Se o problema persistir, entre em contato com o suporte.',
            icon: 'error',
            confirmButtonText: 'Voltar para a Home',
            reverseButtons: true,
            allowOutsideClick: false
            }).then(() => {
              store.dispatch('page/resetDefaultFilter');
              store.dispatch('page/clear');
              store.dispatch('module/setDefaultModule', store.getters['module/getDefaultModule']);
            });

          break;
        }

        case 413: {
          store.dispatch('notification/showNotification', {
            color: 'error',
            text: "Tamanho de arquivo excedeu o limite permitido.",
            showIconNotification: false
          });

          break;
        }

        case 415:
        case 502:
        case 503: {
          store.dispatch('notification/showNotification', {
            color: 'error',
            text: response.statusText,
            showIconNotification: false
          });

          break;
        }

        case 500: {
          store.dispatch('errors/showError500', {
            color: 'error',
            error: response.data,
            status: 500
          });

          break;
        }

        default: {
          store.dispatch('notification/showNotification', {
            color: 'error',
            text: response.data.message,
            showIconNotification: false
          });
        }
      }
    });

    count --;
    if(count === 0){
      store.dispatch('loading/finishLoading');
    }

    return responseError.response;
  }
);
